import { Badge, FormControl, FormLabel, styled } from '@healthinal/ui';
import { ComponentProps, ReactNode } from 'react';
import { FieldValues, UseFormGetFieldState } from 'react-hook-form';

interface SingleLineFormControlProps<TFormValues extends FieldValues> {
  label: ReactNode;
  required?: boolean;
  fieldState: ReturnType<UseFormGetFieldState<TFormValues>>;
  children: ReactNode;
  formControlProps?: Omit<ComponentProps<typeof FormControl>, 'error'>;
  labelSx?: ComponentProps<typeof FormLabel>['sx'];
  showDirtyIndicator?: boolean;
}

export function SingleLineFormControl<TFormValues extends FieldValues>({
  label,
  required = false,
  fieldState,
  children,
  formControlProps,
  labelSx,
  showDirtyIndicator = true,
}: SingleLineFormControlProps<TFormValues>) {
  return (
    <FormControl
      sx={{ display: 'grid', gap: 1, gridTemplateColumns: '155px minmax(0, 1fr)', alignItems: 'start' }}
      error={!!fieldState.error}
      {...formControlProps}>
      <Badge
        variant="solid"
        badgeInset="50% 8px"
        invisible={!showDirtyIndicator || !fieldState.isDirty}
        color={fieldState.error ? 'danger' : 'warning'}
        sx={{ alignSelf: 'start' }}
        slotProps={{ badge: { sx: { boxShadow: 'none' } } }}>
        <FormLabel sx={{ m: 0, py: 0.75, lineHeight: '23px', ...labelSx }}>
          {label}
          {required && <span style={{ marginLeft: 4, color: 'var(--joy-palette-danger-500)' }}>*</span>}
        </FormLabel>
      </Badge>
      <div style={{ alignSelf: 'start' }}>{children}</div>
    </FormControl>
  );
}

export const SingeLineFormGrid = styled('div')`
  display: grid;
  gap: 1rem;
  grid-template-columns: minmax(0, 1fr);
  align-items: start;
`;
